import { customColors } from '@apollo/orbit';
import React from 'react';

const { bg, border, text } = customColors;

/**
 * Component to render `<style>` including styles for `.Resizer`
 */
export const ResizerStyles = ({
  additionalCss,
}: {
  additionalCss?: string;
}) => (
  <style>
    {`.Resizer {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .Resizer.horizontal {
      padding: 6px 0;
      cursor: row-resize;
      width: 100%;
    }

    .Resizer.vertical {
      padding: 0 6px;
      cursor: col-resize;
      height: 100%;
    }

    .Resizer:before {
      content: "";
      display: block;
      background-color: ${border.primary};
      border-radius: 2px;
      transition: background-color 200ms ease-out;
    }

    .Resizer.horizontal:before {
      height: 4px;
      width: 56px;
    }

    .Resizer.vertical:before {
      height: 112px;
      width: 4px;
    }

    .Resizer:hover:before {
      background-color: ${text.secondary};
    }

    .Resizer.disabled {
      cursor: default;
    }

    .Resizer.disabled:before {
      background-color: initial;
    }

    .Resizer.disabled {
      padding: 1px;
    }

    .horizontal.Pane.Pane1 {
      /* Fixes bug in Safari where the top pane will not give space to the bottom pane. */
      height: 0px;
    }

    .monaco-quick-open-widget {
      background-color: ${bg.secondary} !important;
    }
    ${additionalCss ?? ''}
    `}
  </style>
);

export const resizableHandleStyle = `
  /* total width */
  .xxx-mac-style-scrollbars::-webkit-scrollbar {
    background-color: transparent;
    width: 8px;
  }
  /* background of the scrollbar except button or resizer */
  .xxx-mac-style-scrollbars::-webkit-scrollbar-track {
    background-color: transparent;
  }
  /* scrollbar itself */
  .xxx-mac-style-scrollbars::-webkit-scrollbar-thumb {
    background-color: ${border.primary};
    border-radius: 16px;
    border: 4px solid transparent;
  }
  /* set button(top and bottom of the scrollbar) */
  .xxx-mac-style-scrollbars::-webkit-scrollbar-button {
    display: none;
  }
`;
